import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const SpeedAdjustmentButtonWrapper = styled.div<{ alwaysOpen: boolean }>`
    margin-right: 25px;

    ${cssMediaQueryBreakpoints.medium} {
        display: ${p => (p.alwaysOpen ? 'block' : 'none')};
    }
`
